import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    schemesList: [],
    selectedScheme: null,
    lessonPlansList: [],
    selectedLessonPlan: null,
    assignmentsList: [],
    classAssignments: [],
    leavesList: [],
    teacherStats: null,
    loading: false,
    error: null,
    response: null,
    statestatus: "idle",
};

const teacherToolsSlice = createSlice({
    name: "teacherTools",
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        getSchemesSuccess: (state, action) => {
            state.schemesList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getSchemeSuccess: (state, action) => {
            state.selectedScheme = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getLessonsSuccess: (state, action) => {
            state.lessonPlansList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getLessonSuccess: (state, action) => {
            state.selectedLessonPlan = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getAssignmentsSuccess: (state, action) => {
            state.assignmentsList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getClassAssignmentsSuccess: (state, action) => {
            state.classAssignments = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getLeavesSuccess: (state, action) => {
            state.leavesList = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getStatsSuccess: (state, action) => {
            state.teacherStats = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        stuffDone: (state) => {
            state.statestatus = "added";
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getFailed: (state, action) => {
            state.response = action.payload;
            state.loading = false;
            state.error = null;
        },
        getError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        underToolControl: (state) => {
            state.statestatus = "idle";
            state.loading = false;
            state.response = null;
            state.error = null;
        },
    },
});

export const {
    getRequest,
    getSchemesSuccess,
    getSchemeSuccess,
    getLessonsSuccess,
    getLessonSuccess,
    getAssignmentsSuccess,
    getClassAssignmentsSuccess,
    getLeavesSuccess,
    getStatsSuccess,
    stuffDone,
    getFailed,
    getError,
    underToolControl,
} = teacherToolsSlice.actions;

export const teacherToolsReducer = teacherToolsSlice.reducer;
